/* Created by Interactive 63 - https://interactive63.com */
/**
 * The keyboard shortcut sheet: a modal list of every shortcut, opened with H or "?" or from the Help
 * menu. It is built on first use and reused afterwards.
 */
import { h } from '../ui/dom';
import { SHORTCUT_GROUPS } from './shortcuts-list';

export class ShortcutsDialog {
  private dialog: HTMLDialogElement | null = null;

  /** Opens the sheet, creating it the first time. */
  open(): void {
    this.dialog ??= this.build();
    if (!this.dialog.open) this.dialog.showModal();
  }

  /** Whether the sheet is showing. */
  isOpen(): boolean {
    return this.dialog?.open ?? false;
  }

  /** Closes the sheet. */
  close(): void {
    this.dialog?.close();
  }

  /** Builds the dialog with one table per group of shortcuts. */
  private build(): HTMLDialogElement {
    const close = h('button', { type: 'button' }, 'Close');
    const dialog = h(
      'dialog',
      { class: 'settings-dialog shortcuts-dialog', 'aria-labelledby': 'shortcuts-title' },
      h(
        'header',
        { class: 'dialog-header' },
        h('h3', { id: 'shortcuts-title' }, 'Keyboard shortcuts'),
        close,
      ),
      h(
        'div',
        { class: 'shortcuts-body', tabindex: 0, role: 'region', 'aria-label': 'Shortcut list' },
        h(
          'p',
          { class: 'shortcuts-note' },
          'Shortcuts are ignored while you are typing in a field, except Escape.',
        ),
        ...SHORTCUT_GROUPS.map((group) =>
          h(
            'section',
            null,
            h('h4', null, group.title),
            h(
              'table',
              null,
              h('caption', { class: 'visually-hidden' }, `${group.title} shortcuts`),
              h(
                'tbody',
                null,
                ...group.shortcuts.map((shortcut) =>
                  h(
                    'tr',
                    null,
                    h('th', { scope: 'row' }, h('kbd', null, shortcut.keys)),
                    h('td', null, shortcut.action),
                  ),
                ),
              ),
            ),
          ),
        ),
      ),
    );
    close.addEventListener('click', () => {
      dialog.close();
    });
    document.body.append(dialog);
    return dialog;
  }
}
